import {
    getTrendsData,
    filterTrendsData,
    titleCase,
    onFilterSelection,
    onProductAdGroupsSelectionChanged,
} from "./utils";
import store from "../store";
import {
    updateTrendsDataOne,
    updateTrendsDataTwo,
} from "@features/modalSlice";
import {
    updateMainGridFilters,
    updateCampaignFilters,
    updateAdgroupFilters,
    updatePoCheckedNode,
    updateAdCheckedNode,
    updateCaCheckedNode,
    updatePdCheckedNode,
    updateProductFilters,
    updatePortfolioFilters,
    updatePdGridFilters,
    updateCaGridFilters,
    updateAdGridFilters,
    updatePoGridFilters,
} from "@features/filtersSlice";
import { getFilterCount } from "./filters";
import { GridApi, GridReadyEvent, RowNode } from "ag-grid-community";
import { TFilterData, TGetTrendsData, TSelectionValue } from "./common-types";
import { updateAdgroupSelectionData, updateCampaignsSelectionData } from "@/features/selectedDataSlice";
import { map } from "underscore";

type TFilters = {
    values: TFilterData[];
    filterType: string;
};

type TFilterValue = {
    [x: string]: TFilters;
};

type TAllFilterValues = {
    module: string;
    Filters?: TFilterValue;
    caFilters?: TFilterValue;
    kwFilters?: TFilterValue;
    adFilters?: TFilterValue;
    pdFilters?: TFilterValue;
    plFilters?: TFilterValue;
};

export function onPortfolioSelectionChanged(event: GridReadyEvent) {
    const gridApi = event.api;
    const value: TSelectionValue = {
        module: "portfolios",

        campaignFilters: {
            filterKey: "portfolio_id",
            filterData: [],
        },

        keywordFilters: {
            filterKey: "portfolio_id",
            filterData: [],
        },
        adgroupFilters: {
            filterKey: "portfolio_id",
            filterData: [],
        },

        productFilters: {
            filterKey: "portfolio_id",
            filterData: [],
        },
        placementsFilters: {
            filterKey: "portfolio_id",
            filterData: [],
        },
    };

    const selectedNodes = gridApi
        .getSelectedNodes()
        .filter((node) => node.displayed);

    selectedNodes.forEach((node) => {
        value.campaignFilters.filterData.push(node.data.portfolio_id);
        value.keywordFilters.filterData.push(node.data.portfolio_id);
        value.adgroupFilters.filterData.push(node.data.portfolio_id);
        value.productFilters.filterData.push(node.data.portfolio_id);
        value.placementsFilters.filterData.push(node.data.portfolio_id);
    });
    store.dispatch(updatePortfolioFilters(value));
    getFilterCount("portfolios");
    const { campaignFilters, keywordFilters, adgroupFilters, productFilters, placementsFilters } =
        value;

    const filterValues = {
        module: "portfolios",
        caFilters: {
            [campaignFilters.filterKey]: {
                values: campaignFilters.filterData,
                filterType: "set",
            },
        },
        kwFilters: {
            [keywordFilters.filterKey]: {
                values: keywordFilters.filterData,
                filterType: "set",
            },
        },
        adFilters: {
            [adgroupFilters.filterKey]: {
                values: adgroupFilters.filterData,
                filterType: "set",
            },
        },
        pdFilters: {
            [productFilters.filterKey]: {
                values: productFilters.filterData,
                filterType: "set",
            },
        },
        plFilters: {
            [placementsFilters.filterKey]: {
                values: placementsFilters.filterData,
                filterType: "set",
            },
        },
    };

    store.dispatch(updateMainGridFilters(filterValues.module));
    store.dispatch(updatePoGridFilters(filterValues));

    if (selectedNodes.length !== 0) {
        store.dispatch(updatePoCheckedNode(selectedNodes));
    } else {
        store.dispatch(updatePoCheckedNode([]));
    }

    onFilterSelection("portfolio_id", selectedNodes, gridApi);
}

export function onCampaignSelectionChanged(event: GridReadyEvent) {
    const gridApi = event.api;
    const value: TSelectionValue = {
        module: "campaigns",

        keywordFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },
        adgroupFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },

        productFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },
        placementsFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },
    };

    // const selectedNodes = gridApi.getSelectedNodes();
    const selectedNodes: RowNode[] = gridApi
        .getSelectedNodes()
        .filter((node) => node.displayed);
        

    selectedNodes.forEach((node: RowNode) => {
        value.keywordFilters.filterData.push(node.data.sys_campaign_id);
        value.adgroupFilters.filterData.push(node.data.sys_campaign_id);
        value.productFilters.filterData.push(node.data.sys_campaign_id);
        value.placementsFilters.filterData.push(node.data.sys_campaign_id);
    });
    store.dispatch(updateCampaignFilters(value));
    getFilterCount("campaigns");
    const { keywordFilters, adgroupFilters, productFilters, placementsFilters } = value;

    const filterValues: TAllFilterValues = {
        module: "campaigns",
        kwFilters: {
            [keywordFilters.filterKey]: {
                values: keywordFilters.filterData,
                filterType: "set",
            },
        },
        adFilters: {
            [adgroupFilters.filterKey]: {
                values: adgroupFilters.filterData,
                filterType: "set",
            },
        },
        pdFilters: {
            [productFilters.filterKey]: {
                values: productFilters.filterData,
                filterType: "set",
            },
        },
        plFilters: {
            [placementsFilters.filterKey]: {
                values: placementsFilters.filterData,
                filterType: "set",
            },
        },
    };
    store.dispatch(updateMainGridFilters(filterValues.module));
    store.dispatch(updateCaGridFilters(filterValues));

    if (selectedNodes.length !== 0) {
        const selectedData = map(selectedNodes, node => node.data)
        store.dispatch(updateCaCheckedNode(selectedNodes));
        store.dispatch(updateCampaignsSelectionData(selectedData));
    } else {
        store.dispatch(updateCaCheckedNode([]));
        store.dispatch(updateCampaignsSelectionData([]));
    }

    onFilterSelection("sys_campaign_id", selectedNodes, gridApi);
}

export function onAdGroupSelectionChanged(event: GridReadyEvent) {
    const gridApi = event.api;
    const value: TSelectionValue = {
        module: "adgroups",

        keywordFilters: {
            filterKey: "sys_adgroup_id",
            filterData: [],
        },
        campaignFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },

        productFilters: {
            filterKey: "sys_adgroup_id",
            filterData: [],
        },
        placementsFilters: {
            filterKey: "sys_adgroup_id",
            filterData: [],
        },
    };

    // const selectedNodes = gridApi.getSelectedNodes();
    const selectedNodes: RowNode[] = gridApi
        .getSelectedNodes()
        .filter((node) => node.displayed);

    selectedNodes.forEach((node: RowNode) => {
        value.keywordFilters.filterData.push(node.data.sys_adgroup_id);
        value.campaignFilters.filterData.push(node.data.sys_campaign_id);
        value.productFilters.filterData.push(node.data.sys_adgroup_id);
        value.placementsFilters.filterData.push(node.data.sys_adgroup_id);
    });
    store.dispatch(updateAdgroupFilters(value));
    getFilterCount("adgroups");
    const { keywordFilters, campaignFilters, productFilters, placementsFilters } = value;

    const filterValues: TAllFilterValues = {
        module: "adgroups",
        kwFilters: {
            [keywordFilters.filterKey]: {
                values: keywordFilters.filterData,
                filterType: "set",
            },
        },
        caFilters: {
            [campaignFilters.filterKey]: {
                values: campaignFilters.filterData,
                filterType: "set",
            },
        },
        pdFilters: {
            [productFilters.filterKey]: {
                values: productFilters.filterData,
                filterType: "set",
            },
        },
        plFilters: {
            [placementsFilters.filterKey]: {
                values: placementsFilters.filterData,
                filterType: "set",
            },
        },
    };

    store.dispatch(updateMainGridFilters(filterValues.module));
    store.dispatch(updateAdGridFilters(filterValues));

    if (selectedNodes.length !== 0) {
        const selectedData = map(selectedNodes, node => node.data)
        store.dispatch(updateAdCheckedNode(selectedNodes));
        store.dispatch(updateAdgroupSelectionData(selectedData));
    } else {
        store.dispatch(updateAdCheckedNode([]));
        store.dispatch(updateAdgroupSelectionData([]));
    }

    onFilterSelection("sys_adgroup_id", selectedNodes, gridApi);
}

export function onProductSelectionChanged(event: GridReadyEvent) {
    const gridApi = event.api;
    const value: TSelectionValue = {
        module: "products",

        keywordFilters: {
            filterKey: "top_asin",
            filterData: [],
        },

        campaignFilters: {
            filterKey: "sys_campaign_id",
            filterData: [],
        },

        adgroupFilters: {
            filterKey: "sys_adgroup_id",
            filterData: [],
        },
        placementsFilters: {
            filterKey: "top_asin",
            filterData: [],
        },
    };

    // const selectedNodes = event.api.getSelectedNodes();
    const selectedNodes = gridApi
        .getSelectedNodes()
        .filter((node) => node.displayed);

    selectedNodes.forEach((node) => {
        // value.keywordFilters.filterData.push(node.data.top_asin_id);
        value.campaignFilters.filterData.push(node.data.sys_campaign_id);
        value.adgroupFilters.filterData.push(node.data.sys_adgroup_id);
        // value.placementsFilters.filterData.push(node.data.top_asin);
    });
    store.dispatch(updateProductFilters(value));
    getFilterCount("products");
    const { keywordFilters, campaignFilters, adgroupFilters, placementsFilters } = value;

    const filterValues = {
        module: "products",
        kwFilters: {
            [keywordFilters.filterKey]: {
                values: keywordFilters.filterData,
                filterType: "set",
            },
        },
        caFilters: {
            [campaignFilters.filterKey]: {
                values: campaignFilters.filterData,
                filterType: "set",
            },
        },
        adFilters: {
            [adgroupFilters.filterKey]: {
                values: adgroupFilters.filterData,
                filterType: "set",
            },
        },
        plFilters: {
            [placementsFilters.filterKey]: {
                values: placementsFilters.filterData,
                filterType: "set",
            },
        },
    };

    store.dispatch(updateMainGridFilters(filterValues.module));
    store.dispatch(updatePdGridFilters(filterValues));

    if (selectedNodes.length !== 0) {
        store.dispatch(updatePdCheckedNode(selectedNodes));
    } else {
        store.dispatch(updatePdCheckedNode([]));
    }

    onFilterSelection("top_product", selectedNodes, gridApi);
    onProductAdGroupsSelectionChanged(event);
}

export const applyCheckedFilter = async (gridApi: GridApi) => {
    /**?
     * ! Getting api data but unable to reflect it on the grid...
     */
    const state = store.getState();
    const {
        mainGridFilters,
        poGridFilters,
        caGridFilters,
        adGridFilters,
        pdGridFilters,
        activeTab,
        poCheckedNode,
        caCheckedNode,
        adCheckedNode,
        pdCheckedNode,
    } = state;
    if (
        poCheckedNode.value.length ||
        caCheckedNode.value.length ||
        adCheckedNode.value.length ||
        pdCheckedNode.value.length
    ) {
        const currentTab = activeTab.value;
        const module = mainGridFilters.value;
        switch (module) {
            case "portfolios":
                if (
                    currentTab === "keywords" ||
                    currentTab === "adgroups" ||
                    currentTab === "campaigns" ||
                    currentTab === "products" ||
                    currentTab === "placements"
                ) {
                    const { kwFilters } = poGridFilters.value as Record<
                        string,
                        TFilters
                    >;
                    const { plFilters } = poGridFilters.value as Record<
                        string,
                        TFilters
                    >;
                    const kw = {
                        ...gridApi.getFilterModel(),
                        ...(kwFilters && poCheckedNode.value.length !== 0
                            ? kwFilters
                            : {}),
                        ...(plFilters && poCheckedNode.value.length !== 0
                            ? plFilters
                            : {}),
                    };
                    gridApi.setFilterModel(kw);
                }
                break;

            case "campaigns":
                if (
                    currentTab === "keywords" ||
                    currentTab === "adgroups" ||
                    currentTab === "products" ||
                    currentTab === "placements"
                ) {
                    const { kwFilters } = caGridFilters.value as Record<
                        string,
                        TFilters
                    >;
                    const { plFilters } = caGridFilters.value as Record<
                        string,
                        TFilters
                    >;
                    const kw = {
                        ...gridApi.getFilterModel(),
                        ...(kwFilters && caCheckedNode.value.length !== 0
                            ? kwFilters
                            : {}),
                        ...(plFilters && caCheckedNode.value.length !== 0
                            ? plFilters
                            : {}),
                    };
                    gridApi.setFilterModel(kw);
                }
                break;

            case "adgroups":
                if (adGridFilters) {
                    const { kwFilters, caFilters } =
                        adGridFilters.value as Record<string, TFilters>;
                    const { plFilters } = adGridFilters.value as Record<
                        string,
                        TFilters
                    >;
                    if (
                        currentTab === "keywords" ||
                        currentTab === "products" ||
                        currentTab === "placements"
                    ) {
                        const kw = {
                            ...gridApi.getFilterModel(),
                            ...(kwFilters && adCheckedNode.value.length !== 0
                                ? kwFilters
                                : {}),
                            ...(plFilters && adCheckedNode.value.length !== 0
                                ? plFilters
                                : {}),
                        };
                        gridApi.setFilterModel(kw);
                    }

                    if (currentTab === "campaigns") {
                        const ca = {
                            ...gridApi.getFilterModel(),
                            ...(caFilters && adCheckedNode.value.length !== 0
                                ? caFilters
                                : {}),
                        };
                        gridApi.setFilterModel(ca);
                    }
                }

                break;

            case "products":
                if (pdGridFilters) {
                    const { kwFilters, caFilters, adFilters, plFilters } =
                        pdGridFilters.value as Record<string, TFilters>;
                    if (currentTab === "keywords") {
                        const kw = {
                            ...gridApi.getFilterModel(),
                            ...(kwFilters && pdCheckedNode.value.length !== 0
                                ? kwFilters
                                : {}),
                        };
                        gridApi.setFilterModel(kw);
                    }

                    if (currentTab === "products") {
                        const pl = {
                            ...gridApi.getFilterModel(),
                            ...(plFilters && pdCheckedNode.value.length !== 0
                                ? plFilters
                                : {}),
                        };
                        gridApi.setFilterModel(pl);
                    }

                    if (currentTab === "campaigns") {
                        const ca = {
                            ...gridApi.getFilterModel(),
                            ...(caFilters && pdCheckedNode.value.length !== 0
                                ? caFilters
                                : {}),
                        };
                        gridApi.setFilterModel(ca);
                    }

                    if (currentTab === "adgroups") {
                        const ad = {
                            ...gridApi.getFilterModel(),
                            ...(adFilters && pdCheckedNode.value.length !== 0
                                ? adFilters
                                : {}),
                        };
                        gridApi.setFilterModel(ad);
                    }
                }
                break;
        }
        /* 
         ! Note:
         * We are redrawing the nodes because while selecting filters using checkbox,
         * the grid rows are haveing a lot of space between then and the are not re-aligning
         * even using sortingbycolumn and refreshCells
        */
        gridApi.redrawRows();
    }
};

function selectChangeHandler(
    e: React.ChangeEvent<HTMLSelectElement>,
    dataIndex: number
) {
    const trendType = sessionStorage.getItem("trendType");
    const attributeSelectionIndex = dataIndex;
    const attributeSelectionValue = e.target.value;
    const data = filterTrendsData(trendType, attributeSelectionValue);
    const seriesObject = {
        name: titleCase(attributeSelectionValue),
        type: !attributeSelectionIndex ? "column" : "spline",
        data: data,
        yAxis: attributeSelectionIndex,
        dataLabels: {
            enabled: !attributeSelectionIndex,
            inside: false,
            align: "center",
            format: "Bid: {point.cpc}",
        },
    };

    if (dataIndex === 0) {
        store.dispatch(updateTrendsDataOne(seriesObject));
    } else {
        store.dispatch(updateTrendsDataTwo(seriesObject));
    }
}

const selectDefaultAttributes = () => {
    const trendType = sessionStorage.getItem("trendType");
    const data1 = filterTrendsData(trendType, "impression");
    const data2 = filterTrendsData(trendType, "acos");
    const seriesObject1 = {
        name: "Impressions",
        type: "column",
        data: data1,
        yAxis: 0,
        dataLabels: {
            enabled: true,
            inside: false,
            align: "center",
            format: "Bid: {point.cpc}",
        },
    };
    const seriesObject2 = {
        name: "ACoS",
        type: "spline",
        data: data2,
        yAxis: 1,
        dataLabels: {
            enabled: false,
            inside: false,
            align: "center",
            format: "Bid: {point.cpc}",
        },
    };

    store.dispatch(updateTrendsDataOne(seriesObject1));
    store.dispatch(updateTrendsDataTwo(seriesObject2));
};

const trendClickHandler = async (
    id: TGetTrendsData,
    type: string
) => {
    const data = await getTrendsData(id, type);
    sessionStorage.setItem(`${type}Trend`, JSON.stringify(data));
};

export { trendClickHandler, selectChangeHandler, selectDefaultAttributes };
